/**
 * /app/{slug}/exit-tasks — now part of Inbox → Tasks (nav-build spec C).
 * Exit tasks HR gave me (a handover, returning access, …) are listed with
 * every other to-do on /tasks, where I still mark each one started or
 * done. Stored notification links and bookmarks keep working: this route
 * redirects to the Tasks list narrowed to exit tasks.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/exit-tasks")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$tenantSlug/tasks",
      params: { tenantSlug: params.tenantSlug },
      search: { type: "exit" },
      replace: true,
    });
  },
});
